import type { BlockExport } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { HeroHeadersBlock } from "@circle-react-shared/BuilderUI/constants/BlockCategories";
import { backgroundColor } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/backgroundColor";
import { backgroundImage } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/backgroundImage";
import { margin } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/margin";
import { padding } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/padding";
import {
  DesignProp,
  GeneralProp,
  MarginsProp,
  PaddingsProp,
} from "@circle-react-shared/BuilderUI/constants/PropCategories";
import { salesPrimaryBlockDefaultStyles } from "../constants";
import { SalesBlock1 as Block } from "./SalesBlock1";
import { defaultData } from "./SalesBlock1DefaultData";
import imagePreview from "./imagePreview.png";

export const SalesBlock1: BlockExport = {
  type: "component",
  Block,
  imagePreview: {
    type: "image-url",
    lg: imagePreview,
  },
  defaultData,
  meta: {
    name: "Hero Header Sales 1",
    nameI18n: "builder_ui.block_type.sales.block_1",
    version: 1,
    category: [HeroHeadersBlock],
    props: {
      badges: {
        name: "Badges",
        nameI18n: "builder_ui.prop_type.badges",
        prop: "children",
        accepts: ["Basic", "Media", "Text", "Actions", "Layout"],
        type: "children",
      },
      leftContent: {
        name: "Left Content",
        nameI18n: "builder_ui.prop_type.left_content",
        prop: "children",
        accepts: ["Basic", "Media", "Text", "Actions", "Layout"],
        type: "children",
      },
      rightContent: {
        name: "Right Content",
        nameI18n: "builder_ui.prop_type.right_content",
        prop: "children",
        accepts: ["Basic", "Media", "Text", "Actions", "Layout"],
        type: "children",
      },
      buttons: {
        name: "Buttons",
        nameI18n: "builder_ui.prop_type.buttons",
        prop: "children",
        accepts: ["Basic", "Media", "Text", "Actions", "Layout"],
        type: "children",
      },
      userSatisfaction: {
        name: "User Satisfaction",
        nameI18n: "builder_ui.prop_type.user_satisfaction",
        prop: "children",
        accepts: ["Basic", "Media", "Text", "Actions", "Layout"],
        type: "children",
      },
      styles: {
        name: "Styles",
        nameI18n: "builder_ui.prop_type.styles",
        prop: "styles",
        attributes: {
          backgroundColor: {
            ...backgroundColor,
            category: [DesignProp, GeneralProp],
            defaultValue: salesPrimaryBlockDefaultStyles.backgroundColor,
          },
          backgroundImage: {
            ...backgroundImage,
            category: [DesignProp, GeneralProp],
          },
          padding: {
            ...padding,
            category: [DesignProp, PaddingsProp],
            defaultValue: salesPrimaryBlockDefaultStyles.padding,
          },
          margin: {
            ...margin,
            category: [DesignProp, MarginsProp],
            defaultValue: salesPrimaryBlockDefaultStyles.margin,
          },
        },
        type: "styles",
      },
    },
  },
};
